import React from "react";
import {Button, Form, FormCheck, FormGroup, Modal} from "react-bootstrap";
import {GlobalContext} from "../../GlobalContext";

const DISMISS_REASON_LIST = 'ReferralUpload-DismissReasons';
const QUEUED = 'QUEUED';
const OTHER = 'OTHER';

export default class ReferralUploadCancelModal extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            reasons: [],
            selection: null,
            otherReason: ''
        };
    }

    componentDidMount() {
        this.context.cachedGet(`/pickList/${DISMISS_REASON_LIST}`, 60)
            .then(d => {
                if (d && d.data) {
                    this.setState({reasons: d.data});
                }
            });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.show && !this.props.show) {
            this.setState({selection: null, otherReason: ''});
        }
    }

    dismissReason = () =>
        this.state.selection === OTHER ? this.state.otherReason.trim() : this.state.selection;

    submit = () => {
        const queued = this.state.selection === QUEUED;
        this.props.onSubmit(queued ? 'QUEUED' : 'DISMISSED', queued ? null : this.dismissReason());
    }

    canSubmit = () => {
        if (!this.state.selection) return false;
        if (this.state.selection === QUEUED) return true;
        return !!this.dismissReason();
    }

    render() {
        return <Modal show={this.props.show} onHide={this.props.onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>Cancel Referral Upload</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <p>What would you like to do with the extracted referral information?</p>
                    <FormGroup>
                        <FormCheck
                            type="radio"
                            id="referral-cancel-queued"
                            name="referralCancelAction"
                            label="Save for later / return to queue"
                            checked={this.state.selection === QUEUED}
                            onChange={() => this.setState({selection: QUEUED})}
                        />
                        {this.state.reasons.map(r =>
                            <FormCheck
                                key={r.id}
                                type="radio"
                                id={`referral-cancel-dismiss-${r.id}`}
                                name="referralCancelAction"
                                label={`Dismiss (${r.value})`}
                                checked={this.state.selection === r.value}
                                onChange={() => this.setState({selection: r.value})}
                            />)}
                        <FormCheck
                            type="radio"
                            id="referral-cancel-dismiss-other"
                            name="referralCancelAction"
                            label="Dismiss (other)"
                            checked={this.state.selection === OTHER}
                            onChange={() => this.setState({selection: OTHER})}
                        />
                        {this.state.selection === OTHER &&
                            <div className="ml-4 mr-2 mt-1">
                                <Form.Control size="sm" maxLength={100} autoFocus
                                              placeholder="Enter reason" value={this.state.otherReason}
                                              onChange={e => this.setState({otherReason: e.target.value})}/>
                            </div>}
                    </FormGroup>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.props.onCancel}>Cancel</Button>
                <Button variant="dark" onClick={this.submit} disabled={!this.canSubmit()}>Submit</Button>
            </Modal.Footer>
        </Modal>;
    }
}
